export class CustomFormValidity {
    constructor() {
        const forms = document.getElementsByTagName('form');
        const supportedElements = ['input', 'textarea', 'select'];

        forms.forEach((form) => {
            let formHasTabs = form.querySelector('.nav-tabs-wrapper') != null,
                formHasSubmitButton = form.querySelector('button[type="submit"]:not(.formnovalidate)') != null;

            if (formHasTabs && formHasSubmitButton) {
                // Add formnovalidate attribute to submit button to prevent browser validation
                form.querySelector('button[type="submit"]').setAttribute('formnovalidate', '');

                // Add event listener to submit button to validate form
                form.addEventListener('submit', event => {
                    event.preventDefault();

                    // Check if form is valid
                    if (!form.checkValidity()) {
                        for (let c = 0; c < form.elements.length; c++) {
                            let element = form.elements[c];

                            // Check if element is supported and visible and not valid
                            if (supportedElements.includes(element.tagName.toLowerCase())
                                && element.type !== 'hidden'
                                && !element.checkValidity()
                            ) {
                                // Check if element is inside a tab and tab is not visible
                                if (element.closest('.tab-pane') && !element.checkVisibility()) {
                                    let parentTabId = element.closest('.tab-pane').id,
                                        parentTabLink = document.querySelector("a[href='#" + parentTabId + "']");

                                    parentTabLink.click();
                                    element.reportValidity();
                                    break;
                                } else {
                                    element.reportValidity();
                                    break;
                                }
                            }
                        }
                    } else {
                        form.submit();
                    }
                });
            }
        });
    }
}
